/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForResourceToSbomMappingAutomatic extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForResourceToSbomMappingAutomatic");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForResourceToSbomMappingAutomatic.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForResourceToSbomMappingAutomatic>): BackgroundJobPayloadForResourceToSbomMappingAutomatic {
        let obj = Object.assign(new BackgroundJobPayloadForResourceToSbomMappingAutomatic(), model);
        BackgroundJobPayloadForResourceToSbomMappingAutomatic.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForResourceToSbomMappingAutomatic>): BackgroundJobPayloadForResourceToSbomMappingAutomatic {
        if (!model) return null;
        return BackgroundJobPayloadForResourceToSbomMappingAutomatic.newInstance(<BackgroundJobPayloadForResourceToSbomMappingAutomatic> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForResourceToSbomMappingAutomatic) {
        if (!obj) return;

        models.BackgroundJobPayloadForResourceToSbomMappingAutomatic.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForResourceToSbomMappingAutomatic): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForResourceToSbomMappingAutomatic.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
